import { ThemeProvider } from '@slal/ui/theme-provider';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from '~/routes';
import { MobileDetector, ScrollToTop } from './components';
import { ABTestProvider, AnalyticsProvider, FormDataProvider } from './providers';

const App = () => {
    return (
        <ThemeProvider>
            <BrowserRouter>
                <AnalyticsProvider>
                    <FormDataProvider>
                        <ABTestProvider>
                            <ScrollToTop />
                            <MobileDetector />
                            <AppRoutes />
                        </ABTestProvider>
                    </FormDataProvider>
                </AnalyticsProvider>
            </BrowserRouter>
        </ThemeProvider>
    );
};

export default App;
